import { TFunction } from "i18next";
import { Colleague } from "../../../features/Connections/types/Colleague.type";
import { CapacityObject } from "../../../features/Reports/typings/reports.types";
import * as _ from "lodash";

export function handleInitialDepartmentOptions({
  remoteUsers,
  entityData,
  selectedDepartmentIds,
  t
}: {
  remoteUsers: Colleague[] | undefined;
  entityData: (CapacityObject | undefined)[] | undefined;
  selectedDepartmentIds: string[] | undefined;
  t: TFunction;
}): { id: string; name: string }[] {
  if (!remoteUsers || !entityData?.length) return [];

  const bothFloorsUsersData = entityData.flatMap(data => data?.capacity.distinctTotalUsers);
  const reportedUsers = remoteUsers.filter(user =>
    bothFloorsUsersData?.some(data => data?.includes(user.userId))
  );

  if (reportedUsers.length > 0) {
    const departments = reportedUsers
      .map(user => {
        if (user.departmentId !== null && user.departmentName) {
          return {
            id: user.departmentId,
            name: user.departmentName
          };
        }
        return undefined;
      })
      .filter((item): item is { id: string; name: string } => item !== undefined);

    const mapped =
      selectedDepartmentIds && selectedDepartmentIds.length > 0
        ? departments
        : [...departments, { id: "null", name: t("No department assigned") }];

    const reportedDepartments = _.uniqBy(mapped, dept => dept.name);
    return reportedDepartments;
  }
  return [];
}
